import type { SVGProps } from 'react';
const SvgAttachment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 20"
    height={20}
    fill="none"
    width={21}
    {...props}
  >
    <path
      d="m10.15 19.41-.3-.03c-1.287-.13-2.571-.747-3.518-1.691q-1.378-1.374-1.686-3.398c-.03-.2-.035-.644-.041-4.96-.005-3.332-.001-4.812.014-4.982a4.14 4.14 0 0 1 2.064-3.214 4.15 4.15 0 0 1 4.55.282c.367.273.794.745 1.053 1.164.292.473.511 1.119.573 1.684.014.13.021 1.714.021 4.833 0 4.02-.004 4.66-.03 4.809a2.39 2.39 0 0 1-1.99 1.965 2.387 2.387 0 0 1-2.71-1.965c-.026-.148-.03-.713-.03-4.148 0-3.967 0-3.977.041-4.087a.67.67 0 0 1 .324-.342.63.63 0 0 1 .82.297l.045.084.01 4c.01 3.825.012 4.005.047 4.11.101.3.317.565.565.695.23.12.54.157.806.094.37-.087.679-.386.815-.789.035-.106.037-.284.043-4.52.006-4.445.001-4.82-.066-5.15a2.9 2.9 0 0 0-.74-1.408 2.884 2.884 0 0 0-4.86 1.185c-.117.41-.112.124-.104 5.343.007 5.28-.003 4.851.133 5.392a4.66 4.66 0 0 0 2.45 3.018 4.62 4.62 0 0 0 3.52.239 4.62 4.62 0 0 0 2.692-2.349c.165-.338.262-.596.34-.908.134-.531.125-.254.137-4.172l.012-3.56.052-.11a.66.66 0 0 1 .318-.317.65.65 0 0 1 .51-.003c.126.061.261.196.317.316l.043.094v3.54c0 2.853-.005 3.58-.027 3.75a6.2 6.2 0 0 1-.696 2.166 5.9 5.9 0 0 1-1.887 2.05 5.9 5.9 0 0 1-2.55.955 10 10 0 0 1-1.08.037"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAttachment;
